define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/_base",
	"csi/heading/Number",
	"csi/util"
], function(declare,_,csiHeading,NumberRen,util) {

	var	_getTotalWeight = function(/*Context*/ctx) {
		var	node = ctx.getNode();
		if (node.Sections) {
			return _.reduce(node.Sections, function(memo, url) {
				return memo + ctx.cache.getNode(url).Weight;
			}, 0);
		}

		return null;
	};

	return declare(NumberRen, {
		_getRenderCSS: function(/*Context*/ctx, /*Heading*/h) {
			// summary: total weight for template and color red if not 100
			var	css = this.inherited(arguments);
			var	v = _getTotalWeight(ctx);

			if ((v != null) && (util.truncate(v, 0.0001) != 1.0)) {
				css += " " + csiHeading.CSS_ERROR;
			}

			return css;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: replace revision name with Total label
			var	v = _getTotalWeight(ctx);
			return (v == null) ? this.inherited(arguments) : v;
		}
	});
});
